import { z } from "zod";

// Update a brand. No `source_id` — a brand cannot move networks (the products composite FK
// (brand_id, source_id) has no ON UPDATE CASCADE); the store leaves source_id untouched and does
// not rewrite products.brand_name. `active` stays bare .optional() (never null — house rule).
export const updateProductBrandRequestSchema = z.object({
  external_id: z.string().min(1).max(100).nullable().optional(),
  name: z.string().min(1).max(200).nullable().optional(),
  active: z.boolean().optional(),
});
